

export default function analytics(event, data) {

    //if user is in-house don't fire any event 
    const { user, isAuthenticated } = useSanctumAuth();
    const emailIds = ['poddardiamonds', 'friendlydiamonds']
    if (isAuthenticated.value) {
        const containsKeyword = emailIds.some(email => user.value.email.includes(email));
        if (containsKeyword) {
            return
        }
    }

    const importedAnalytics = import('~/utils/analytics/analytics.helper.js')
    importedAnalytics.then((analyticsHelper) => {
        // console.log('analytics imported:', analyticsHelper)

        // // Check if analytics is a function
        // if (typeof analytics === 'function') {
        //     console.log('Calling analytics function with event:', event, 'and data:', data);
        analyticsHelper.trigerGtagUtils(event, data);
        // }

    }).catch(error => {
        console.error('Error importing analytics:', error);
        throw error;
    });
}

